export const FETCH_EXERCISES = 'EXERCISES/FETCH';
export const GET_DETAILS = 'EXERCISES/GET_DETAILS';
export const SAVE_DETAILS = 'EXERCISES/SAVE_DETAILS';
export const SET_EXERCISES = 'EXERCISES/SET';
export const SET_LOADING_STATE = 'EXERCISES/SET_LOADING_STATE';
